// components
import {
  ControlledAutoComplete,
  ControlledDatePicker,
  ControlledDutyHourTypeSelector,
  ControlledPlanUnitSelector
} from 'components/shared';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// types
import { RequestSectionProps } from './RequestSection.types';

export const RequestSection = ({
  requestReasonList,
  rosterFunctionOptions,
  referenceDate,
  selectedDate
}: RequestSectionProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'flexMatch.newFlexRequestDrawer'
  });
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <MultiStepForm.Section
      title={t('request')}
      validateFields={[
        'reason',
        'date',
        'costCenter',
        'rosterFunction',
        'dutyTypeId'
      ]}
    >
      <ControlledAutoComplete
        optionLabelProp="name"
        idProperty="id"
        variant="outlined"
        control={control}
        name="reason"
        label={tCommon('flexHistory.requestReason')}
        options={requestReasonList ?? []}
        fullWidth
      />

      <ControlledDatePicker
        control={control}
        name="date"
        label={tCommon('date')}
        fullWidth
      />

      <ControlledPlanUnitSelector
        name="costCenter"
        control={control}
        variant="outlined"
        doNotPersist
        fullWidth
        hideGroups
        hideNavigation
        isSingleSelect
      />

      <ControlledAutoComplete
        optionLabelProp="description"
        idProperty="id"
        variant="outlined"
        control={control}
        name="rosterFunction"
        label={tCommon('flexHistory.requestFunction')}
        options={rosterFunctionOptions ?? []}
        fullWidth
      />

      <ControlledDutyHourTypeSelector
        control={control}
        name="dutyTypeId"
        label={tCommon('dutyHourType')}
        variant="outlined"
        referenceDate={referenceDate}
        disabled={!selectedDate}
        fullWidth
      />
    </MultiStepForm.Section>
  );
};
